
/* global Android:false */
/* global RN:false */

export default {
  /**
   * Figures out the client that opens the web page.
   */
  getClientType() {
    // If opened in an Android WebView, an Android object will be created.
    if (typeof Android !== 'undefined') {
      return 'android_webview';
    }

    // If opened in a React-Native WebView, a RN object will be created.
    if (typeof RN !== 'undefined') {
      return 'rn_webview';
    }

    // Fallback to web at last.
    return 'web';
  },

  getClientWebViewBridge() {
    const clientType = this.getClientType();
    if (clientType === 'android_webview') {
      return Android;
    } else if (clientType === 'rn_webview') {
      return RN;
    } else {
      return null;
    }
  },

  isInAppWebview() {
    const clientType = this.getClientType();
    return clientType === 'android_webview' ||
      clientType === 'ios_webview' ||
      clientType === 'rn_webview';
  },

  isInRniOSWebView() {
    const webViewBridge = this.getClientWebViewBridge();
    return webViewBridge && webViewBridge.deviceOSType === 'ios';
  },

  isInRnAndroidWebView() {
    const webViewBridge = this.getClientWebViewBridge();
    return webViewBridge && webViewBridge.deviceOSType === 'android';
  },
};
